import { connect } from 'react-redux'
import Alert from './Alert.jsx'
import { ackAlert } from 'redux/notifications/actions'

const mapDispatchToProps = (dispatch, ownProps) => ({
    acknowledge: () => dispatch(ackAlert(ownProps.alert.id)),
})

export const AlertContainer = connect(
    undefined,
    mapDispatchToProps,
)(Alert)
